let data: any = localStorage.getItem('userData')
let dataJson = JSON.parse(data)
let userData: any = dataJson || {
    id: "",
    top_menu_list: [],
    left_menu_list: []
}

// 首页不需要做过滤
userData.top_menu_list.unshift({
    id: "1",
    name: "首页",
    p_id: "",
    url: "",
    route_url: "/",
    menu_type: 3,
    order_num: 1,
    children: [],
})

userData.left_menu_list.unshift({
    id: "8",
    name: "首页",
    p_id: "1",
    url: "",
    route_url: "",
    menu_type: 2,
    order_num: 1,
    children: [
        {
            id: "9",
            name: "概览",
            p_id: "8",
            url: "",
            route_url: "/",
            menu_type: 2,
            order_num: 1,
            children: null
        }
    ]
})

export default userData